// extracted by mini-css-extract-plugin
export default {"NavigationMenu":"MobileNavigation_NavigationMenu__H25nO","burgerButton":"MobileNavigation_burgerButton__JMtUm"};